import { Colors } from '@spotahome/ui-library';
import {
  isPhabletScreen,
  isTabletScreen,
  isMobileScreen
} from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';
import {
  Bar,
  BarChart,
  Cell,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis
} from 'recharts';

const mobileBarSize = 15;
const desktopBarSize = 45;
const verticalBarChartHeight = 300;

const HorizontalBarChart = ({ data }) => {
  const isMobileOrTablet = () =>
    isMobileScreen() || isPhabletScreen() || isTabletScreen();

  const barSize = isMobileOrTablet() ? mobileBarSize : desktopBarSize;

  return (
    <ResponsiveContainer width="100%" height={verticalBarChartHeight}>
      <BarChart
        layout="vertical"
        data={data}
        barSize={barSize}
        margin={{ top: 5, right: 60, bottom: 5, left: 0 }}
      >
        <XAxis type="number" hide domain={[0, 100]} />
        <YAxis
          type="category"
          dataKey="label"
          axisLine={false}
          tickLine={false}
          width={100}
          tick={{ fontSize: 14 }}
        />
        <Bar
          dataKey="percentage"
          barSize={40}
          radius={[100, 100, 100, 100]}
          background={{
            fill: Colors['ultra-light'],
            radius: [100, 100, 100, 100]
          }}
        >
          {data?.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={Colors.interaction} />
          ))}
          <LabelList
            dataKey="percentage"
            position="right"
            formatter={value => `${value}%`}
            style={{ fontSize: '16px', fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default HorizontalBarChart;
